import { lazy, Suspense } from 'react';
import LoadingCom from '../../components/LoadingCom';
import PageErrorBoundary from '../../components/PageErrorBoundary';

const TaxSettingsPage = lazy(() => import('./Index'));

export default function SuspendedTaxSettingsPage() {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <TaxSettingsPage />
      </Suspense>
    </PageErrorBoundary>
  );
}
